<template>
  <div>
    <ui-header :heading="$tc('models.user', 2)">
      <ui-link class="add_new_button" type="text" :route="{ name: 'departments-users-create' }">{{
        `${$tc('actions.add_new', 1)} ${$tc('models.user')}`
      }}</ui-link>
    </ui-header>
    <department-user-list
      :users="users"
      v-on:removeUser="removeUser"
      v-loading="loading"
    />
  </div>
</template>

<script>
import UiHeader from '@/components/ui/UiHeader';
import UiLink from '@/components/ui/UiLink';
import DepartmentUserList from '../components/DepartmentUserList';
import {getDepartmentUsers, deleteDepartmentUser, getDepartment} from '../api';

export default {
  data() {
    return {
      users: [],
      loading: false
    };
  },

  components: {
    UiHeader,
    UiLink,
    DepartmentUserList
  },

  methods: {
    async getUsers() {
      this.loading = true;
      try {
        const users = await getDepartmentUsers(
          this.$router.history.current.params.id
        );
        if (users.length > 0) {
          this.users = users.sort((a, b) => (a.lastName > b.lastName ? 1 : -1));
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        const msg = {
          message: this.$t('errors.load', { msg: this.$tc('user', 2) }),
          type: 'error'
        };
        this.$message(msg);
      }
    },

    async removeUser(userId) {
      this.loading = true;
      try {
        const success = await deleteDepartmentUser(
          this.$router.history.current.params.id,
          userId
        );
        if (success) this.users = this.users.filter(u => u.id !== userId);
      } catch (error) {
        this.$message({ message: this.$t('errors.general'), type: 'error' });
      }
      this.loading = false;
    }
  },

  created() {
    this.getUsers();
  },

  async mounted() {
    let department = await getDepartment(this.$route.params.id);
    this.$store.commit('changeBreadcrumbs', [
      {name: "models.departments", link: "/app/departments/"},
      {name: department.name, link: "/app/departments/" + department.id + "/users"},
      {name: "models.users", link: "/app/departments/" + department.id + "/users"}
    ]);
  },
};
</script>

<style scoped>
.add_new_button {
  background-color: white;
  border: solid 1px black;
  color: black;
}
</style>